module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Sending-2710528ec5df4ee670756ea5a9665eff.svg";